var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.tag))])])
}
var staticRenderFns = []

export { render, staticRenderFns }